import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronUp18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 4.93935L14.5303 10.4697L13.4697 11.5303L9 7.06067L4.53033 11.5303L3.46967 10.4697L9 4.93935Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronUp18.displayName = 'ChevronUp18';
export default ChevronUp18;
